// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"373":"29adc1e1","453":"ed3810f9"}[chunkId] + ".chunk.js";
};